import React, { Component, ErrorInfo, ReactNode } from 'react';
import { View } from 'react-native';
import { captureBoundaryError } from '@/lib/sentry';
import { ErrorState } from './error-state';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  /** Rota em que o erro aconteceu, anotada no evento do Sentry. */
  route?: string | null;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    captureBoundaryError(error, this.props.route ?? null);
    this.props.onError?.(error, errorInfo);
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
    });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <View className="flex-1">
          <ErrorState
            title="Algo deu errado"
            message="Ocorreu um erro inesperado. Por favor, tente novamente."
            onRetry={this.handleReset}
            retryLabel="Tentar novamente"
          />
        </View>
      );
    }

    return this.props.children;
  }
}
